import ServiceTemplate from '@/components/ServiceTemplate';

export default function StatementOfUse() {
  const data = {
    title: 'Statement of Use Filing Services',
    subtitle: 'Expert Statement of Use preparation and filing to complete your trademark registration.',
    overviewTitle: 'What is a Statement of Use?',
    overviewImage: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4',
    description: [
      'If you filed your trademark application based on Intent-to-Use, you must file a Statement of Use showing actual use in commerce before the USPTO will issue a registration certificate. This critical step completes the registration process.',
      'The Statement of Use requires proper specimens showing trademark use on goods or in connection with services, along with dates of first use. Incorrect specimens or dates are common reasons for refusal.',
      'Our experienced attorneys ensure your Statement of Use is properly prepared with acceptable specimens and accurate information, avoiding delays and additional office actions.'
    ],
    benefits: [
      { title: 'Proper Specimens', description: 'Ensure specimens meet USPTO requirements for your goods/services.' },
      { title: 'Accurate Dating', description: 'Correctly identify and document first use dates.' },
      { title: 'Deadline Management', description: 'Timely filing to avoid application abandonment.' },
      { title: 'Extension Assistance', description: 'File extensions if additional time is needed.' },
      { title: 'Error Prevention', description: 'Avoid common mistakes that lead to refusals.' },
      { title: 'Complete Registration', description: 'Finalize registration and receive certificate.' }
    ],
    process: [
      { title: 'Analysis & Strategy', description: 'Thorough review of issues and development of comprehensive response strategy.' },
      { title: 'Response Preparation & Filing', description: 'Expert drafting and timely filing of all required responses and documentation.' },
      { title: 'Follow-Up & Resolution', description: 'Monitoring progress and ensuring successful resolution of all matters.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential trademark filing',
        price: '$599',
        period: '+ USPTO fees ($250-$350)',
        features: [
          'Preliminary trademark search',
          'Single class filing',
          'USPTO application preparation',
          'Filing with USPTO',
          'Email support',
          'Status monitoring'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete trademark package',
        price: '$999',
        period: '+ USPTO fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Comprehensive search report',
          'Multi-class discounts available',
          'Office action response (1 included)',
          'Priority processing',
          'Trademark monitoring (6 months)',
          'Phone & email support'
        ]
      },
      {
        name: 'Premium',
        description: 'Full-service trademark protection',
        price: '$1,499',
        period: '+ USPTO fees',
        features: [
          'Everything in Professional',
          'Global trademark search',
          'Unlimited office action responses',
          'International filing coordination',
          'Trademark monitoring (12 months)',
          'Enforcement support',
          'Dedicated attorney access'
        ]
      }
    ],
    faqs: [
      { question: 'When must I file a Statement of Use?', answer: 'You must file within 6 months of receiving the Notice of Allowance, though extensions of up to 30 additional months are available.' },
      { question: 'What specimens are acceptable?', answer: 'For goods: labels, tags, packaging, or photos showing the mark on the product. For services: advertising, brochures, websites, or signs showing the mark with the services.' },
      { question: 'What if I haven\'t started using the mark yet?', answer: 'You can request extensions in 6-month increments, up to 30 months total, by showing good faith intent to use the mark.' },
      { question: 'How many extensions can I get?', answer: 'Up to five 6-month extensions are available, providing up to 36 months total from the Notice of Allowance date to file the Statement of Use.' },
      { question: 'What dates do I need to provide?', answer: 'You must provide the date of first use anywhere and the date of first use in interstate commerce for each class of goods/services.' },
      { question: 'Can I add goods/services at this stage?', answer: 'No, you cannot add goods/services. You can only claim use for items already in your application, or delete items not yet in use.' },
      { question: 'What happens after filing?', answer: 'The USPTO examines your Statement of Use. If acceptable, your registration certificate is issued, typically within 2-3 months.' },
      { question: 'What if my specimens are rejected?', answer: 'You\'ll receive an office action allowing you to submit corrected specimens or arguments. Proper initial preparation helps avoid this delay.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
